import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {createSelectionOptionsUtil} from '../../../Util/commonUtility';
import {getAllChapters} from '../../../Store/Actions';
import AttendeesCartComponent from '../../../Components/UserComponents/AttendeesCart';
import {
  normalRegistrationByUserAndEventId,
  UpdateAttendee,
  applyCouponCodes,
  deleteAttendee,
  getAttendesByUserAndEventId,
  getAttendeesByTransactionId,
  updateFoodAndRegistrationOptions,
} from '../../../Store/Actions/eventRegister';
import {getEventOptionsByEventId} from '../../../Store/Actions/eventOptions';
import {Navigate, useNavigate, useParams} from 'react-router-dom';

const AttendeesCartContainer = () => {
  const {id, transactionId} = useParams();
  let dispatch = useDispatch();
  const navigate = useNavigate();
  const {allAttendees} = useSelector(({eventRegister}) => eventRegister);
  const {allAttendeesAfterPayment} = useSelector(
    ({eventRegister}) => eventRegister,
  );
  const [allAttendeesData, setAllAttendeesData] = useState([]);
  const [eventLocalChapterData, setEventLocalChapterData] = useState();
  const [allEventOptionsFoodData, setAllEventOptionsFoodData] = useState([]);
  const [allEventOptionsRegistrationData, setAllEventOptionsRegistrationData] =
    useState([]);
  const {getEventOptionByEventId} = useSelector(
    ({eventOptions}) => eventOptions,
  );
  const [eventOptionsFoodData, setEventOptionsFoodData] = useState([]);
  const [attendeesData, setAttendeesData] = useState([]);
  const [totalCartPrice, setTotalCartPrice] = useState(0);
  const [appliedCartCoupon, setAppliedCartCoupon] = useState();
  const [isAppliedCoupon, setIsAppliedCoupon] = useState(false);
  const [eventType, setEventType] = useState('');
  const [eventName, setEventName] = useState('');
  const [eventISOnline, setEventISOnline] = useState(false);
  const [eventAvailableForWebcast, setEventAvailableForWebcast] = useState({
    isAvailable: false,
    availableChapters: [],
    eventLocalChapter: null,
  });
  const [isSponsorAvailable, setIsSponsorAvailable] = useState(false);
  const allChapters = useSelector((state) => state.chapters.allChapters);

  useEffect(() => {
    if (!allChapters) {
      dispatch(getAllChapters());
    }
  }, []);

  useEffect(() => {
    if (getEventOptionByEventId) {
      const foodOptionsWithNoFood = getEventOptionByEventId?.data?.food;
      const filteredRegData = getEventOptionByEventId?.data?.registration;
      setEventOptionsFoodData(
        createSelectionOptionsUtil(
          foodOptionsWithNoFood,
          'id',
          'name',
          'price',
          eventLocalChapterData,
        ),
      );
      setAllEventOptionsRegistrationData(
        createSelectionOptionsUtil(
          filteredRegData,
          'id',
          'name',
          'price',
          eventLocalChapterData,
        ),
      );
    }
  }, [getEventOptionByEventId, eventLocalChapterData]);

  useEffect(() => {
    if (eventOptionsFoodData) {
      setAllEventOptionsFoodData(() => [
        ...eventOptionsFoodData,
        {value: 'no-food', label: 'No Food'},
      ]);
    }
  }, [eventOptionsFoodData]);

  useEffect(() => {
    transactionId
      ? getAttendeeByTransactionId(transactionId)
      : getAttendeeByEventId(id);
  }, [transactionId, id]);

  useEffect(() => {
    if (transactionId) {
      const commonDataVar = allAttendeesAfterPayment?.data?.eventRegistrations;
      if (allAttendeesAfterPayment) {
        const Data = commonDataVar?.attendees;
        setAllAttendeesData(Data);
        const eventLocalChapterData = allChapters?.data?.chapters?.find(
          (obj) => obj.id === allAttendeesAfterPayment?.data?.local_chapter_id,
        );
        setEventLocalChapterData(eventLocalChapterData);
        setEventName(allAttendeesAfterPayment?.data?.event_name);
        setEventAvailableForWebcast({
          isAvailable: allAttendeesAfterPayment?.data?.is_available_for_webcast,
          availableChapters:
            allAttendeesAfterPayment?.data?.webcast_available_for_chapters,
          eventLocalChapter:
            allAttendeesAfterPayment?.data?.event_local_chapter,
        });
      } else {
        getAttendeeByTransactionId(transactionId);
      }
    } else {
      if (allAttendees) {
        setTotalCartPrice({
          total_price_per_cart: allAttendees?.data?.total_price,
          discount: allAttendees?.data?.discount,
          discounted_price: allAttendees?.data?.discounted_price,
          refund_credit: allAttendees?.data?.refund_credit,
          refund_credit_for_regular_attendees:
            allAttendees?.data?.refund_credit,
        });
        const Data = allAttendees?.data?.event_registrations?.attendees;
        setAllAttendeesData(Data);
        const eventLocalChapterData = allChapters?.data?.chapters?.find(
          (obj) => obj.id === allAttendees?.data?.local_chapter_id,
        );
        setEventLocalChapterData(eventLocalChapterData);
        setAppliedCartCoupon(allAttendees?.data?.discount_code);
        setEventType(allAttendees?.data?.event_type_name);
        setEventName(allAttendees?.data?.event_name);
        setEventISOnline(allAttendees?.data?.is_online);
        setEventAvailableForWebcast({
          isAvailable: allAttendees?.data?.is_available_for_webcast,
          availableChapters: allAttendees?.data?.webcast_available_for_chapters,
          eventLocalChapter: allAttendees?.data?.event_local_chapter,
        });
        setIsSponsorAvailable(allAttendees?.data?.sponsorship_available);
      } else {
        getAttendeeByEventId(id);
      }
    }
  }, [allAttendees, allAttendeesAfterPayment, transactionId, id, allChapters]);

  useEffect(() => {
    if (isAppliedCoupon) {
      getAttendeeByEventId(id);
    }
  }, [isAppliedCoupon]);
  useEffect(() => {
    if (id) {
      dispatch(getEventOptionsByEventId(id));
    }
  }, [id]);

  useEffect(() => {
    if (allAttendeesData) {
      const Data = Array.isArray(allAttendeesData)
        ? allAttendeesData.map((item) => {
            return {
              ...item,
              food_option: item?.event_registration_options?.food,
              registration_option:
                item?.event_registration_options?.registration,
            };
          })
        : [];
      setAttendeesData(Data);
    }
  }, [allAttendeesData]);

  const getAttendeeByEventId = (id) => {
    const attendeeType = 'normal';
    dispatch(getAttendesByUserAndEventId(id, attendeeType));
  };
  const getAttendeeByTransactionId = (transactionId) => {
    dispatch(getAttendeesByTransactionId(transactionId));
  };
  const applyCouponCode = async (Data) => {
    dispatch(applyCouponCodes(Data, setIsAppliedCoupon));
  };
  const editAttendeeById = (
    Data,
    id,
    setEditingKey,
    form,
    setIsAddAttendee,
  ) => {
    transactionId
      ? dispatch(
          updateFoodAndRegistrationOptions(Data, id, setEditingKey, form),
        )
      : dispatch(
          UpdateAttendee(Data, id, setEditingKey, form, setIsAddAttendee),
        );
  };
  const deleteAttendeeById = async (id) => {
    dispatch(deleteAttendee(id));
  };
  const paymentByUserRegistration = async (id) => {
    return dispatch(
      normalRegistrationByUserAndEventId(
        id,
        navigate,
        totalCartPrice?.discounted_price === 0,
        true,
      ),
    );
  };
  // Pre-pay coupon cart is now on Add Attendees; keep this route for post-pay edits.
  if (!transactionId) {
    return <Navigate to={`/addAttendees/${id}`} replace />;
  }

  return (
    <div>
      <AttendeesCartComponent
        isSponsorAvailable={isSponsorAvailable}
        applyCouponCode={(Data) => {
          applyCouponCode(Data);
        }}
        attendeesData={attendeesData}
        allEventOptionsFoodData={allEventOptionsFoodData}
        allEventOptionsRegistrationData={allEventOptionsRegistrationData}
        inPersonRemaining={getEventOptionByEventId?.data?.in_person_remaining}
        totalCartPrice={totalCartPrice}
        editAttendeeById={(Data, id, setEditingKey, form, setIsAddAttendee) => {
          editAttendeeById(Data, id, setEditingKey, form, setIsAddAttendee);
        }}
        deleteAttendeeById={(id) => {
          deleteAttendeeById(id);
        }}
        paymentByUserRegistration={(id) => {
          return paymentByUserRegistration(id);
        }}
        appliedCartCoupon={appliedCartCoupon}
        eventType={eventType}
        eventName={eventName}
        eventISOnline={eventISOnline}
        setAttendeesData={setAttendeesData}
        eventLocalChapterData={eventLocalChapterData}
        eventAvailableForWebcast={eventAvailableForWebcast}
      />
    </div>
  );
};

export default AttendeesCartContainer;
